export default {"src":"/_next/static/media/betslip.acc64159.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};